import { Expose } from 'class-transformer';

import { Default } from '@lib/common/decorators';
import { SnModel } from '@lib/common/models';

export class SnLiveApplication extends SnModel {
  @Expose()
  public id: string;

  @Expose()
  public name: string;

  @Expose()
  @Default([])
  public protocols: string[];

  @Expose()
  @Default(4)
  public chunkCount: number;

  @Expose()
  @Default(6)
  public chunkDuration: number;

  @Expose()
  public pushLogin: string;

  @Expose()
  public pushPassword: string;

  @Expose()
  @Default(false)
  public cloudPull: boolean;

  @Expose()
  public pullAppliance: string;

  @Expose()
  public pullIdleTime: number;

  @Expose()
  public appliance: string;

  constructor(data: any = {}) {
    super();

    this.fromJSON(data);
  }

  get protocolsString(): string {
    return this.protocols.join(', ');
  }
}
